export default __webpack_public_path__ + "static/media/Bloodsire Boots.56dbc2b5.jpg";